module.exports = __webpack_public_path__ + "img/actTwo.0a91b160.png";